import DynamicFormPayloadModelBase from '../_generated/modelBases/dynamic-form-payload-model-base';

export default class DynamicFormPayloadModel extends DynamicFormPayloadModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
